// extracted by mini-css-extract-plugin
export default {"bonuses":"KT0Uf","error":"r6uxQ","loader":"esZjy","iconPoints":"Ge6Xx","wrapper":"ro4S3","count":"gRmxD","bonusPopup":"X3n47","popup":"UkqKr","iconClose":"Ly76Y","link":"_jJjF"};